import api from "./axiosConfig";

export interface BillingSubscription {
  subscriptionId?: string | null;
  tier: string;
  status: string;
  currentPeriodEnd?: string | null;
  customerId?: string | null;
  amountCents?: number | null;
  currency?: string | null;
}

export interface PlanUsage {
  planName: string;
  currentClients: number;
  maxClients: number;
  currentTeamSeats: number;
  maxTeamSeats: number;
  whiteLabelEnabled: boolean;
  customDomainEnabled: boolean;
}

export interface BillingInvoice {
  id: string;
  number?: string | null;
  amountPaidCents: number;
  currency: string;
  status: string;
  created?: string | null;
  hostedInvoiceUrl?: string | null;
  pdfUrl?: string | null;
}

export const billingApi = {
  getSubscription: async (): Promise<BillingSubscription> => {
    const response = await api.get<BillingSubscription>("/billing/subscription");
    return response.data;
  },

  getUsage: async (): Promise<PlanUsage> => {
    const response = await api.get<PlanUsage>("/billing/usage");
    return response.data;
  },

  createCheckoutSession: async (tier: string): Promise<{ url: string; sessionId: string }> => {
    const response = await api.post<{ url: string; sessionId: string }>("/billing/checkout", { tier });
    return response.data;
  },

  verifyCheckout: async (sessionId: string): Promise<BillingSubscription> => {
    const response = await api.post<BillingSubscription>("/billing/verify-checkout", { sessionId });
    return response.data;
  },

  getInvoices: async (): Promise<BillingInvoice[]> => {
    const response = await api.get<BillingInvoice[]>("/billing/invoices");
    return response.data;
  },

  cancelSubscription: async (): Promise<void> => {
    await api.post("/billing/cancel", {});
  },

  changePlan: async (plan: string): Promise<BillingSubscription> => {
    const response = await api.post<BillingSubscription>("/billing/change-plan", { plan });
    return response.data;
  },
};
